import React, { useState, useEffect } from "react";
import axios from "axios";
import ButtonPrimary from "../components/Button-primary";
import ButtonSecondary from "../components/Button-secondary";

const Home = () => {
  const [fetchLivePrices, setFetchLivePrices] = useState([]);
  const [companiesHoldBTC, setCompaniesHoldBTC] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const numberFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });

  useEffect(() => {
    if (localStorage.getItem("isConnected") === "yes") {
      setIsConnected(true);
    }
  }, []);

  useEffect(() => {
    const fetchPricesFunction = async () => {
      const response = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin&vs_currencies=USD`
      );
      setFetchLivePrices(response.data);
    };
    fetchPricesFunction();
  }, []);

  const formatPrice = (price) => {
    return numberFormat.format(price);
  };

  useEffect(() => {
    const fetchCompaniesHoldBTCFunction = async () => {
      try {
        const response = await axios.get(
          "https://api.coingecko.com/api/v3/companies/public_treasury/bitcoin"
        );
        setCompaniesHoldBTC(Array(response.data).flat());
      } catch (error) {
        console.log(error);
      }
    };
    fetchCompaniesHoldBTCFunction();
  }, []);

  if (!companiesHoldBTC) {
    return (
      <div className="text-center min-h-[80vh] flex justify-center items-center">
        <div role="status">
          <svg
            aria-hidden="true"
            className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col text-center items-center space-y-8 m-auto text-indigo-600 font-bold">
      <section className="mt-20 mx-auto max-w-screen-xl pb-4 px-4 sm:px-8">
        <div className="text-center space-y-4">
          <h1 className="text-gray-800 font-bold text-4xl md:text-5xl">
            Welcome to
            <span className="text-indigo-600"> Cryptools</span>
          </h1>
          <p className="text-gray-500 max-w-xl mx-auto leading-relaxed">
            Some crypto tools to make life easier
          </p>
        </div>
        <div className="mt-12 justify-center items-center space-y-3 sm:space-x-6 sm:space-y-0 sm:flex">
          {!isConnected && !window.location.pathname.includes("/login") && (
            <>
              <ButtonPrimary
                text={"Register"}
                className={""}
                link={"/register"}
              />
              <ButtonSecondary text={"Login"} link={"/login"} />
            </>
          )}
        </div>
      </section>
      <div className="p-8 w-full">
        <div className="bg-gray-50 pt-12 sm:pt-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-4xl text-center">
              <h2 className="text-3xl tracking-tight text-gray-900 sm:text-4xl">
                Live prices
              </h2>
              <p className="mt-3 text-xl text-gray-500 sm:mt-4">
                Discover the current prices of BTC, ETH, and BNB! Take a look at
                the rates displayed below:
              </p>
            </div>
          </div>
          <div className="mt-10 bg-white pb-12 sm:pb-16">
            <div className="relative">
              <div className="absolute inset-0 h-1/2 bg-gray-50"></div>
              <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl">
                  <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
                    <div className="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
                      <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                        Bitcoin
                      </dt>
                      <dd className="order-1 text-5xl font-bold tracking-tight text-indigo-600">
                        ${formatPrice(fetchLivePrices?.bitcoin?.usd)}
                      </dd>
                    </div>
                    <div className="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r">
                      <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                        ETH
                      </dt>
                      <dd className="order-1 text-5xl font-bold tracking-tight text-indigo-600">
                        ${formatPrice(fetchLivePrices?.ethereum?.usd)}
                      </dd>
                    </div>
                    <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
                      <dt className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                        BNB
                      </dt>
                      <dd className="order-1 text-5xl font-bold tracking-tight text-indigo-600">
                        ${formatPrice(fetchLivePrices?.binancecoin?.usd)}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-8 w-full">
        <div className="bg-gray-50 pt-12 sm:pt-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-4xl text-center">
              <h2 className="text-3xl tracking-tight text-gray-900 sm:text-4xl">
                Companies holdings (BTC)
              </h2>
              <p className="mt-3 text-xl text-gray-500 sm:mt-4">
                The companies tat hold the most BTC
              </p>
            </div>
          </div>
          <div className="mt-10 bg-white pb-12 sm:pb-16">
            <div className="relative">
              <div className="absolute inset-0 h-[110%] bg-gray-50"></div>
              <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <ol className="flex flex-wrap gap-4 pl-0 md:pl-6 list-inside justify-center	">
                  {companiesHoldBTC
                    ? companiesHoldBTC[0].companies
                        ?.slice(0, 10)
                        .map((company, index) => {
                          return (
                            <li
                              key={index}
                              className="list-decimal text-gray-500 bg-white px-2 py-4 rounded-lg border flex items-center w-full md:w-fit"
                            >
                              <span className="mr-4">{index + 1}</span>
                              <div className="flex space-x-2">
                                <h3 className="">{company.name}</h3>{" "}
                                <p className="text-orange-400">
                                  {numberFormat.format(company.total_holdings)}{" "}
                                  <span>₿</span>
                                </p>
                              </div>
                            </li>
                          );
                        })
                    : null}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
